var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrengthBlack40X40(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#272724",
    d: "M39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5C30.7696 0.5 39.5 9.23045 39.5 20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#272724",
    d: "M31.169 30.3311L20.0001 19.1621L8.83105 30.3311"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#272724",
    d: "M31.169 20.2793L20.0001 9.11035L8.83105 20.2793"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrengthBlack40X40);
export default __webpack_public_path__ + "static/media/Strength-black-40x40.0f293e50e9b175bf256d1704efdd5e55.svg";
export { ForwardRef as ReactComponent };